import React, { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Trash2 } from "lucide-react";
import { Button } from "./ui/button";
import { API, BACKEND_URL } from "../lib/api";

/**
 * Generic image uploader used by Admin Service / Event managers.
 * Posts to /api/upload-image, returns the public URL via onUploaded.
 */
export function ImageUploader({ currentUrl, onUploaded, category = "uploads", previewAspect = null, previewMaxWidth = null }) {
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef(null);

  const handleUpload = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('category', category);
      const res = await axios.post(`${API}/upload-image`, formData, {
        withCredentials: true,
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.url) {
        onUploaded(res.data.url);
        toast.success("Image uploadée");
      }
    } catch (error) {
      toast.error(error.response?.data?.detail || "Erreur d'upload");
    } finally {
      setUploading(false);
      if (fileRef.current) fileRef.current.value = '';
    }
  };

  const previewStyle = previewAspect
    ? { aspectRatio: previewAspect, maxWidth: previewMaxWidth || '100%' }
    : null;

  return (
    <div className="space-y-2" data-testid="image-uploader">
      {currentUrl && (
        <div
          className={`rounded-lg overflow-hidden border border-white/10 bg-[#1B132B] flex items-center justify-center ${previewAspect ? '' : 'w-full h-32'}`}
          style={previewStyle || undefined}
        >
          <img
            src={currentUrl.startsWith('/') ? `${BACKEND_URL}${currentUrl}` : currentUrl}
            alt="Preview"
            className={`w-full h-full ${previewAspect ? 'object-contain' : 'object-cover'}`}
            onError={(e) => { e.target.style.display = 'none'; }}
          />
        </div>
      )}
      <div className="flex gap-2">
        <input ref={fileRef} type="file" accept="image/*" onChange={handleUpload} className="hidden" />
        <Button type="button" variant="outline" size="sm" className="border-white/10 text-[#B59ED1] hover:text-white flex-1" onClick={() => fileRef.current?.click()} disabled={uploading} data-testid="upload-btn">
          {uploading ? 'Upload...' : currentUrl ? 'Changer la photo' : 'Ajouter une photo'}
        </Button>
        {currentUrl && (
          <Button type="button" variant="ghost" size="sm" className="text-red-400" onClick={() => onUploaded('')} data-testid="remove-img-btn">
            <Trash2 className="w-3 h-3" />
          </Button>
        )}
      </div>
    </div>
  );
}
